export default {
    // Lorem Ipsum ---------------------------------------------------------- //
    LIButtonText: {
        en: "Lorem ipsum",
        uk: "Lorem ipsum",
    },

    LIGetInTouchText: {
        en: "Lorem Ipsum",
        uk: "Lorem Ipsum",
    },

    LIGetInTouchEmail: {
        en: "Lorem@ipsum.dolor",
        uk: "Lorem@ipsum.dolor",
    },

    LIGetInTouchButton: {
        en: "Lorem Ipsum",
        uk: "Lorem Ipsum",
    },

    LIHeaderText: {
        en: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
        uk: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
    },

    LILogotype: {
        en: "Lorem Ipsum",
        uk: "Lorem Ipsum",
    },

    LIFeaturesHeader: {
        en: "Lorem Ipsum",
        uk: "Lorem Ipsum",
    },

    LIFeaturesText: {
        en: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        uk: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    },

    LIStepsStep1Header: { en: "Step 1", uk: "Step 1" },
    LIStepsStep1Text: { en: "Create an account or log in.", uk: "Create an account or log in." },
    LIStepsStep2Header: { en: "Step 2", uk: "Step 2" },
    LIStepsStep2Text: { en: "Choose the plan you like the most", uk: "Choose the plan you like the most" },
    LIStepsStep3Header: { en: "Step 3", uk: "Step 3" },
    LIStepsStep3Text: { en: "Proceed to checkout", uk: "Proceed to checkout" },

    LINumbersText: { en: "Lorem ipsum dolor sit amet", uk: "Lorem ipsum dolor sit amet" },
    LINumbersNumber: { en: "9999", uk: "9999" },

    LIFeedbacksName: { en: "Lorem Ipsum", uk: "Lorem Ipsum" },
    LIFeedbacksFeedback: {
        en: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        uk: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    },
    LIFeedbacksCompany: { en: "Lorem Ipsum", uk: "Lorem Ipsum" },

    LIOffersButton: { en: "Subscribe", uk: "Subscribe" },
    LIOffersGoToOurStore: { en: "Lorem Ipsum", uk: "Lorem Ipsum" },
    LIOffersCost: { en: "999", uk: "999" },
    LIOffersCurrency: { en: "USD", uk: "USD" },
    LIOffersDescription: { en: "Lorem ipsum dolor sit amet", uk: "Lorem ipsum dolor sit amet" },
    LIOffersFeatures: {
        en: "Lorem ipsum\n Lorem ipsum\n Lorem ipsum\nLorem ipsum\n Lorem ipsum",
        uk: "Lorem ipsum\n Lorem ipsum\n Lorem ipsum\nLorem ipsum\n Lorem ipsum",
    },
    LIOffersTitle: { en: "Lorem Ipsum", uk: "Lorem Ipsum" },

    LIEventsLocation: {
        en: "Kyiv, Nezhalezhnosti sq. 1",
        uk: "Kyiv, Nezhalezhnosti sq. 1",
        pl: "Kyiv, Nezhalezhnosti sq. 1",
    },

    LIMenuLinksHome: { en: "Home", uk: "Home" },
    LIMenuLinksFeatures: { en: "Features", uk: "Features" },
    LIMenuLinksOffers: { en: "Offers", uk: "Offers" },
    LIMenuLinksFeedbacks: { en: "Feedbacks", uk: "Feedbacks" },

    // Lorem Ipsum by Product Type ------------------------------------------ //
    // MobileApp
    LIbPTMobileAppHeader: {
        en: "Get access to a wide range of tools and resources designed to help you succeed!",
        uk: "Get access to a wide range of tools and resources designed to help you succeed!",
    },
    LIbPTMobileAppLogotype: {
        en: "Mobile Application",
        uk: "Mobile Application",
    },
    LIbPTMobileAppButtonText: {
        en: "Get Now",
        uk: "Get Now",
    },
    LIbPTMobileAppFeaturesFeature1Header: {
        en: "Easy-to-Use Dashboard",
        uk: "Easy-to-Use Dashboard",
    },
    LIbPTMobileAppFeaturesFeature1Text: {
        en: "Our dashboard is designed to be user-friendly and intuitive, making it easy for you to access all of your business tools and resources in one place.",
        uk: "Our dashboard is designed to be user-friendly and intuitive, making it easy for you to access all of your business tools and resources in one place.",
    },
    LIbPTMobileAppFeaturesFeature2Header: {
        en: "Expert Support Team",
        uk: "Expert Support Team",
    },
    LIbPTMobileAppFeaturesFeature2Text: {
        en: "Need help? Our expert support team is always available to answer your questions and offer guidance.",
        uk: "Need help? Our expert support team is always available to answer your questions and offer guidance.",
    },
    LIbPTMobileAppFeaturesFeature3Header: {
        en: "Customization Options",
        uk: "Customization Options",
    },
    LIbPTMobileAppFeaturesFeature3Text: {
        en: "With Pgbldr, you have the ability to customize your business tools and resources to fit your specific needs.",
        uk: "With Pgbldr, you have the ability to customize your business tools and resources to fit your specific needs.",
    },
    LIbPTMobileAppFeaturesFeature4Header: {
        en: "Scalability",
        uk: "Scalability",
    },
    LIbPTMobileAppFeaturesFeature4Text: {
        en: "With Pgbldr, you have the ability to customize your business tools and resources to fit your specific needs.",
        uk: "With Pgbldr, you have the ability to customize your business tools and resources to fit your specific needs.",
    },

    LIbPTMobileAppStepsStep1Header: { en: "Step 1", uk: "Step 1" },
    LIbPTMobileAppStepsStep1Text: { en: "Create an account or log in.", uk: "Create an account or log in." },
    LIbPTMobileAppStepsStep2Header: { en: "Step 2", uk: "Step 2" },
    LIbPTMobileAppStepsStep2Text: {
        en: "Choose the plan you like the most",
        uk: "Choose the plan you like the most",
    },
    LIbPTMobileAppStepsStep3Header: { en: "Step 3", uk: "Step 3" },
    LIbPTMobileAppStepsStep3Text: { en: "Proceed to checkout", uk: "Proceed to checkout" },

    LIbPTMobileAppNumbersNumber1Text: { en: "happy customers", uk: "happy customers" },
    LIbPTMobileAppNumbersNumber1Number: { en: "123456", uk: "123456" },

    LIbPTMobileAppFeedbacksFeedback1Name: { en: "Startup Owner", uk: "Startup Owner" },
    LIbPTMobileAppFeedbacksFeedback1Feedback: {
        en: "I just wanted to express my sincere gratitude for the outstanding service I have received from your team. As a startup owner, I have a lot on my plate and I am always looking for ways to streamline my processes and maximize my efficiency. Your platform has done just that, and I am so grateful for the value it has added to my business.",
        uk: "I just wanted to express my sincere gratitude for the outstanding service I have received from your team. As a startup owner, I have a lot on my plate and I am always looking for ways to streamline my processes and maximize my efficiency. Your platform has done just that, and I am so grateful for the value it has added to my business.",
    },
    LIbPTMobileAppFeedbacksFeedback1Company: { en: "SEO", uk: "SEO" },

    //
    LIbPTMobileAppOffersOffer1Title: { en: "Basic Plan", uk: "Basic Plan" },
    LIbPTMobileAppOffersOffer1Cost: { en: "1", uk: "1" },
    LIbPTMobileAppOffersOffer1Currency: { en: "USD", uk: "USD" },
    LIbPTMobileAppOffersOffer1Description: {
        en: "This plan is perfect for small businesses just starting out. It includes access to all of the basic tools and resources you need to get started.",
        uk: "This plan is perfect for small businesses just starting out. It includes access to all of the basic tools and resources you need to get started.",
    },
    LIbPTMobileAppOffersOffer1Features: {
        en: "5 tools\nLimited data\nHelp Guide",
        uk: "5 tools\nLimited data\nHelp Guide",
    },
    LIbPTMobileAppOffersOffer1Button: { en: "Subscribe", uk: "Subscribe" },
    LIbPTMobileAppOffersOffer1GoToOurStore: { en: "Lorem ipsum", uk: "Lorem ipsum" },

    //
    LIbPTMobileAppOffersOffer2Title: { en: "Standard Plan", uk: "Standard Plan" },
    LIbPTMobileAppOffersOffer2Cost: { en: "5", uk: "5" },
    LIbPTMobileAppOffersOffer2Currency: { en: "USD", uk: "USD" },
    LIbPTMobileAppOffersOffer2Description: {
        en: "Our Standard Plan is ideal for businesses looking for a little more. In addition to the basic tools and resources, it also includes access to additional features and support.",
        uk: "Our Standard Plan is ideal for businesses looking for a little more. In addition to the basic tools and resources, it also includes access to additional features and support.",
    },
    LIbPTMobileAppOffersOffer2Features: {
        en: "10 tools\nLimited data\n24/7 online support",
        uk: "10 tools\nLimited data\n24/7 online support",
    },
    LIbPTMobileAppOffersOffer2Button: { en: "Subscribe", uk: "Subscribe" },
    LIbPTMobileAppOffersOffer2GoToOurStore: { en: "Lorem ipsum", uk: "Lorem ipsum" },

    //
    LIbPTMobileAppOffersOffer3Title: { en: "Pro Plan", uk: "Pro Plan" },
    LIbPTMobileAppOffersOffer3Cost: { en: "10", uk: "10" },
    LIbPTMobileAppOffersOffer3Currency: { en: "USD", uk: "USD" },
    LIbPTMobileAppOffersOffer3Description: {
        en: "The Pro Plan is perfect for businesses looking to take their operations to the next level. It includes all of the features and resources of the Standard Plan, as well as advanced tools and expert support.",
        uk: "The Pro Plan is perfect for businesses looking to take their operations to the next level. It includes all of the features and resources of the Standard Plan, as well as advanced tools and expert support.",
    },
    LIbPTMobileAppOffersOffer3Features: {
        en: "25 tools\nUnlimited data\n24/7 live support",
        uk: "25 tools\nUnlimited data\n24/7 live support",
    },
    LIbPTMobileAppOffersOffer3Button: { en: "Subscribe", uk: "Subscribe" },
    LIbPTMobileAppOffersOffer3GoToOurStore: { en: "Lorem ipsum", uk: "Lorem ipsum" },

    //
    LIbPTMobileAppOffersOffer4Title: { en: "Enterprise Plan", uk: "Enterprise Plan" },
    LIbPTMobileAppOffersOffer4Cost: { en: "25", uk: "25" },
    LIbPTMobileAppOffersOffer4Currency: { en: "USD", uk: "USD" },
    LIbPTMobileAppOffersOffer4Description: {
        en: "Our Enterprise Plan is designed for larger businesses with more complex needs. It includes everything in the Pro Plan, as well as specialized features and dedicated support.",
        uk: "Our Enterprise Plan is designed for larger businesses with more complex needs. It includes everything in the Pro Plan, as well as specialized features and dedicated support.",
    },
    LIbPTMobileAppOffersOffer4Features: {
        en: "50 tools\nUnlimited data\n24/7 priority support",
        uk: "50 tools\nUnlimited data\n24/7 priority support",
    },
    LIbPTMobileAppOffersOffer4Button: { en: "Subscribe", uk: "Subscribe" },
    LIbPTMobileAppOffersOffer4GoToOurStore: { en: "Lorem ipsum", uk: "Lorem ipsum" },

    LIbPTMobileAppGetInTouchText: { en: "Have any questions left?", uk: "Have any questions left?" },
    LIbPTMobileAppGetInTouchEmail: { en: "Lorem@ipsum.dolor", uk: "Lorem@ipsum.dolor" },
    LIbPTMobileAppGetInTouchButton: { en: "Ask us!", uk: "Ask us!" },

    // WebProduct
    LIbPTWebProductHeader: {
        en: "Get access to a wide range of tools and resources designed to help you succeed!",
        uk: "Get access to a wide range of tools and resources designed to help you succeed!",
    },
    LIbPTWebProductLogotype: {
        en: "Web Product",
        uk: "Web Product",
    },
    LIbPTWebProductButtonText: { en: "Get Now", uk: "Get Now" },
    LIbPTWebProductFeaturesFeature1Header: {
        en: "Easy-to-Use Dashboard",
        uk: "Easy-to-Use Dashboard",
    },
    LIbPTWebProductFeaturesFeature1Text: {
        en: "Our dashboard is designed to be user-friendly and intuitive, making it easy for you to access all of your business tools and resources in one place.",
        uk: "Our dashboard is designed to be user-friendly and intuitive, making it easy for you to access all of your business tools and resources in one place.",
    },
    LIbPTWebProductFeaturesFeature2Header: {
        en: "Expert Support Team",
        uk: "Expert Support Team",
    },
    LIbPTWebProductFeaturesFeature2Text: {
        en: "Need help? Our expert support team is always available to answer your questions and offer guidance.",
        uk: "Need help? Our expert support team is always available to answer your questions and offer guidance.",
    },
    LIbPTWebProductFeaturesFeature3Header: {
        en: "Customization Options",
        uk: "Customization Options",
    },
    LIbPTWebProductFeaturesFeature3Text: {
        en: "With Pgbldr, you have the ability to customize your business tools and resources to fit your specific needs.",
        uk: "With Pgbldr, you have the ability to customize your business tools and resources to fit your specific needs.",
    },
    LIbPTWebProductFeaturesFeature4Header: {
        en: "Scalability",
        uk: "Scalability",
    },
    LIbPTWebProductFeaturesFeature4Text: {
        en: "With Pgbldr, you have the ability to customize your business tools and resources to fit your specific needs.",
        uk: "With Pgbldr, you have the ability to customize your business tools and resources to fit your specific needs.",
    },

    LIbPTWebProductStepsStep1Header: { en: "Step 1", uk: "Step 1" },
    LIbPTWebProductStepsStep1Text: {
        en: "Create an account or log in.",
        uk: "Create an account or log in.",
    },
    LIbPTWebProductStepsStep2Header: { en: "Step 2", uk: "Step 2" },
    LIbPTWebProductStepsStep2Text: {
        en: "Choose the plan you like the most",
        uk: "Choose the plan you like the most",
    },
    LIbPTWebProductStepsStep3Header: { en: "Step 3", uk: "Step 3" },
    LIbPTWebProductStepsStep3Text: {
        en: "Proceed to checkout",
        uk: "Proceed to checkout",
    },

    LIbPTWebProductNumbersNumber1Text: {
        en: "happy customers",
        uk: "happy customers",
    },
    LIbPTWebProductNumbersNumber1Number: {
        en: "123456",
        uk: "123456",
    },

    LIbPTWebProductFeedbacksFeedback1Name: {
        en: "Startup Owner",
        uk: "Startup Owner",
    },
    LIbPTWebProductFeedbacksFeedback1Feedback: {
        en: "I just wanted to express my sincere gratitude for the outstanding service I have received from your team. As a startup owner, I have a lot on my plate and I am always looking for ways to streamline my processes and maximize my efficiency. Your platform has done just that, and I am so grateful for the value it has added to my business.",
        uk: "I just wanted to express my sincere gratitude for the outstanding service I have received from your team. As a startup owner, I have a lot on my plate and I am always looking for ways to streamline my processes and maximize my efficiency. Your platform has done just that, and I am so grateful for the value it has added to my business.",
    },
    LIbPTWebProductFeedbacksFeedback1Company: {
        en: "SEO",
        uk: "SEO",
    },

    //
    LIbPTWebProductOffersOffer1Title: {
        en: "Basic Plan",
        uk: "Basic Plan",
    },
    LIbPTWebProductOffersOffer1Cost: {
        en: "1",
        uk: "1",
    },
    LIbPTWebProductOffersOffer1Currency: {
        en: "USD",
        uk: "USD",
    },
    LIbPTWebProductOffersOffer1Description: {
        en: "This plan is perfect for small businesses just starting out. It includes access to all of the basic tools and resources you need to get started.",
        uk: "This plan is perfect for small businesses just starting out. It includes access to all of the basic tools and resources you need to get started.",
    },
    LIbPTWebProductOffersOffer1Features: {
        en: "5 tools\nLimited data\nHelp Guide",
        uk: "5 tools\nLimited data\nHelp Guide",
    },
    LIbPTWebProductOffersOffer1Button: {
        en: "Subscribe",
        uk: "Subscribe",
    },
    LIbPTWebProductOffersOffer1GoToOurStore: {
        en: "Lorem ipsum",
        uk: "Lorem ipsum",
    },

    //
    LIbPTWebProductOffersOffer2Title: {
        en: "Standard Plan",
        uk: "Standard Plan",
    },
    LIbPTWebProductOffersOffer2Cost: {
        en: "5",
        uk: "5",
    },
    LIbPTWebProductOffersOffer2Currency: {
        en: "USD",
        uk: "USD",
    },
    LIbPTWebProductOffersOffer2Description: {
        en: "Our Standard Plan is ideal for businesses looking for a little more. In addition to the basic tools and resources, it also includes access to additional features and support.",
        uk: "Our Standard Plan is ideal for businesses looking for a little more. In addition to the basic tools and resources, it also includes access to additional features and support.",
    },
    LIbPTWebProductOffersOffer2Features: {
        en: "10 tools\nLimited data\n24/7 online support",
        uk: "10 tools\nLimited data\n24/7 online support",
    },
    LIbPTWebProductOffersOffer2Button: {
        en: "Subscribe",
        uk: "Subscribe",
    },
    LIbPTWebProductOffersOffer2GoToOurStore: {
        en: "Lorem ipsum",
        uk: "Lorem ipsum",
    },

    //
    LIbPTWebProductOffersOffer3Title: {
        en: "Pro Plan",
        uk: "Pro Plan",
    },
    LIbPTWebProductOffersOffer3Cost: {
        en: "10",
        uk: "10",
    },
    LIbPTWebProductOffersOffer3Currency: {
        en: "USD",
        uk: "USD",
    },
    LIbPTWebProductOffersOffer3Description: {
        en: "The Pro Plan is perfect for businesses looking to take their operations to the next level. It includes all of the features and resources of the Standard Plan, as well as advanced tools and expert support.",
        uk: "The Pro Plan is perfect for businesses looking to take their operations to the next level. It includes all of the features and resources of the Standard Plan, as well as advanced tools and expert support.",
    },
    LIbPTWebProductOffersOffer3Features: {
        en: "25 tools\nUnlimited data\n24/7 live support",
        uk: "25 tools\nUnlimited data\n24/7 live support",
    },
    LIbPTWebProductOffersOffer3Button: {
        en: "Subscribe",
        uk: "Subscribe",
    },
    LIbPTWebProductOffersOffer3GoToOurStore: {
        en: "Lorem ipsum",
        uk: "Lorem ipsum",
    },

    //
    LIbPTWebProductOffersOffer4Title: {
        en: "Enterprise Plan",
        uk: "Enterprise Plan",
    },
    LIbPTWebProductOffersOffer4Cost: {
        en: "25",
        uk: "25",
    },
    LIbPTWebProductOffersOffer4Currency: {
        en: "USD",
        uk: "USD",
    },
    LIbPTWebProductOffersOffer4Description: {
        en: "Our Enterprise Plan is designed for larger businesses with more complex needs. It includes everything in the Pro Plan, as well as specialized features and dedicated support.",
        uk: "Our Enterprise Plan is designed for larger businesses with more complex needs. It includes everything in the Pro Plan, as well as specialized features and dedicated support.",
    },
    LIbPTWebProductOffersOffer4Features: {
        en: "50 tools\nUnlimited data\n24/7 priority support",
        uk: "50 tools\nUnlimited data\n24/7 priority support",
    },
    LIbPTWebProductOffersOffer4Button: {
        en: "Subscribe",
        uk: "Subscribe",
    },
    LIbPTWebProductOffersOffer4GoToOurStore: {
        en: "Lorem ipsum",
        uk: "Lorem ipsum",
    },

    LIbPTWebProductGetInTouchText: {
        en: "Have any questions left?",
        uk: "Have any questions left?",
    },
    LIbPTWebProductGetInTouchEmail: {
        en: "Lorem@ipsum.dolor",
        uk: "Lorem@ipsum.dolor",
    },
    LIbPTWebProductGetInTouchButton: {
        en: "Ask us!",
        uk: "Ask us!",
    },

    // CrossPlatform
    LIbPTCrossPlatformHeader: {
        en: "Get access to a wide range of tools and resources designed to help you succeed!",
        uk: "Get access to a wide range of tools and resources designed to help you succeed!",
    },
    LIbPTCrossPlatformLogotype: {
        en: "Crossplatform Product",
        uk: "Crossplatform Product",
    },
    LIbPTCrossPlatformButtonText: { en: "Get Now", uk: "Get Now" },
    LIbPTCrossPlatformFeaturesFeature1Header: {
        en: "Easy-to-Use Dashboard",
        uk: "Easy-to-Use Dashboard",
    },
    LIbPTCrossPlatformFeaturesFeature1Text: {
        en: "Our dashboard is designed to be user-friendly and intuitive, making it easy for you to access all of your business tools and resources in one place.",
        uk: "Our dashboard is designed to be user-friendly and intuitive, making it easy for you to access all of your business tools and resources in one place.",
    },
    LIbPTCrossPlatformFeaturesFeature2Header: {
        en: "Expert Support Team",
        uk: "Expert Support Team",
    },
    LIbPTCrossPlatformFeaturesFeature2Text: {
        en: "Need help? Our expert support team is always available to answer your questions and offer guidance.",
        uk: "Need help? Our expert support team is always available to answer your questions and offer guidance.",
    },
    LIbPTCrossPlatformFeaturesFeature3Header: {
        en: "Customization Options",
        uk: "Customization Options",
    },
    LIbPTCrossPlatformFeaturesFeature3Text: {
        en: "With Pgbldr, you have the ability to customize your business tools and resources to fit your specific needs.",
        uk: "With Pgbldr, you have the ability to customize your business tools and resources to fit your specific needs.",
    },
    LIbPTCrossPlatformFeaturesFeature4Header: {
        en: "Scalability",
        uk: "Scalability",
    },
    LIbPTCrossPlatformFeaturesFeature4Text: {
        en: "With Pgbldr, you have the ability to customize your business tools and resources to fit your specific needs.",
        uk: "With Pgbldr, you have the ability to customize your business tools and resources to fit your specific needs.",
    },

    LIbPTCrossPlatformStepsStep1Header: { en: "Step 1", uk: "Step 1" },
    LIbPTCrossPlatformStepsStep1Text: {
        en: "Create an account or log in.",
        uk: "Create an account or log in.",
    },
    LIbPTCrossPlatformStepsStep2Header: { en: "Step 2", uk: "Step 2" },
    LIbPTCrossPlatformStepsStep2Text: {
        en: "Choose the plan you like the most",
        uk: "Choose the plan you like the most",
    },
    LIbPTCrossPlatformStepsStep3Header: { en: "Step 3", uk: "Step 3" },
    LIbPTCrossPlatformStepsStep3Text: {
        en: "Proceed to checkout",
        uk: "Proceed to checkout",
    },

    LIbPTCrossPlatformNumbersNumber1Text: {
        en: "happy customers",
        uk: "happy customers",
    },
    LIbPTCrossPlatformNumbersNumber1Number: {
        en: "123456",
        uk: "123456",
    },

    LIbPTCrossPlatformFeedbacksFeedback1Name: {
        en: "Startup Owner",
        uk: "Startup Owner",
    },
    LIbPTCrossPlatformFeedbacksFeedback1Feedback: {
        en: "I just wanted to express my sincere gratitude for the outstanding service I have received from your team. As a startup owner, I have a lot on my plate and I am always looking for ways to streamline my processes and maximize my efficiency. Your platform has done just that, and I am so grateful for the value it has added to my business.",
        uk: "I just wanted to express my sincere gratitude for the outstanding service I have received from your team. As a startup owner, I have a lot on my plate and I am always looking for ways to streamline my processes and maximize my efficiency. Your platform has done just that, and I am so grateful for the value it has added to my business.",
    },
    LIbPTCrossPlatformFeedbacksFeedback1Company: {
        en: "SEO",
        uk: "SEO",
    },

    //
    LIbPTCrossPlatformOffersOffer1Title: {
        en: "Basic Plan",
        uk: "Basic Plan",
    },
    LIbPTCrossPlatformOffersOffer1Cost: {
        en: "1",
        uk: "1",
    },
    LIbPTCrossPlatformOffersOffer1Currency: {
        en: "USD",
        uk: "USD",
    },
    LIbPTCrossPlatformOffersOffer1Description: {
        en: "This plan is perfect for small businesses just starting out. It includes access to all of the basic tools and resources you need to get started.",
        uk: "This plan is perfect for small businesses just starting out. It includes access to all of the basic tools and resources you need to get started.",
    },
    LIbPTCrossPlatformOffersOffer1Features: {
        en: "5 tools\nLimited data\nHelp Guide",
        uk: "5 tools\nLimited data\nHelp Guide",
    },
    LIbPTCrossPlatformOffersOffer1Button: {
        en: "Subscribe",
        uk: "Subscribe",
    },
    LIbPTCrossPlatformOffersOffer1GoToOurStore: {
        en: "Lorem ipsum",
        uk: "Lorem ipsum",
    },

    //
    LIbPTCrossPlatformOffersOffer2Title: {
        en: "Standard Plan",
        uk: "Standard Plan",
    },
    LIbPTCrossPlatformOffersOffer2Cost: {
        en: "5",
        uk: "5",
    },
    LIbPTCrossPlatformOffersOffer2Currency: {
        en: "USD",
        uk: "USD",
    },
    LIbPTCrossPlatformOffersOffer2Description: {
        en: "Our Standard Plan is ideal for businesses looking for a little more. In addition to the basic tools and resources, it also includes access to additional features and support.",
        uk: "Our Standard Plan is ideal for businesses looking for a little more. In addition to the basic tools and resources, it also includes access to additional features and support.",
    },
    LIbPTCrossPlatformOffersOffer2Features: {
        en: "10 tools\nLimited data\n24/7 online support",
        uk: "10 tools\nLimited data\n24/7 online support",
    },
    LIbPTCrossPlatformOffersOffer2Button: {
        en: "Subscribe",
        uk: "Subscribe",
    },
    LIbPTCrossPlatformOffersOffer2GoToOurStore: {
        en: "Lorem ipsum",
        uk: "Lorem ipsum",
    },

    //
    LIbPTCrossPlatformOffersOffer3Title: {
        en: "Pro Plan",
        uk: "Pro Plan",
    },
    LIbPTCrossPlatformOffersOffer3Cost: {
        en: "10",
        uk: "10",
    },
    LIbPTCrossPlatformOffersOffer3Currency: {
        en: "USD",
        uk: "USD",
    },
    LIbPTCrossPlatformOffersOffer3Description: {
        en: "The Pro Plan is perfect for businesses looking to take their operations to the next level. It includes all of the features and resources of the Standard Plan, as well as advanced tools and expert support.",
        uk: "The Pro Plan is perfect for businesses looking to take their operations to the next level. It includes all of the features and resources of the Standard Plan, as well as advanced tools and expert support.",
    },
    LIbPTCrossPlatformOffersOffer3Features: {
        en: "25 tools\nUnlimited data\n24/7 live support",
        uk: "25 tools\nUnlimited data\n24/7 live support",
    },
    LIbPTCrossPlatformOffersOffer3Button: {
        en: "Subscribe",
        uk: "Subscribe",
    },
    LIbPTCrossPlatformOffersOffer3GoToOurStore: {
        en: "Lorem ipsum",
        uk: "Lorem ipsum",
    },

    //
    LIbPTCrossPlatformOffersOffer4Title: {
        en: "Enterprise Plan",
        uk: "Enterprise Plan",
    },
    LIbPTCrossPlatformOffersOffer4Cost: {
        en: "25",
        uk: "25",
    },
    LIbPTCrossPlatformOffersOffer4Currency: {
        en: "USD",
        uk: "USD",
    },
    LIbPTCrossPlatformOffersOffer4Description: {
        en: "Our Enterprise Plan is designed for larger businesses with more complex needs. It includes everything in the Pro Plan, as well as specialized features and dedicated support.",
        uk: "Our Enterprise Plan is designed for larger businesses with more complex needs. It includes everything in the Pro Plan, as well as specialized features and dedicated support.",
    },
    LIbPTCrossPlatformOffersOffer4Features: {
        en: "50 tools\nUnlimited data\n24/7 priority support",
        uk: "50 tools\nUnlimited data\n24/7 priority support",
    },
    LIbPTCrossPlatformOffersOffer4Button: {
        en: "Subscribe",
        uk: "Subscribe",
    },
    LIbPTCrossPlatformOffersOffer4GoToOurStore: {
        en: "Lorem ipsum",
        uk: "Lorem ipsum",
    },

    LIbPTCrossPlatformGetInTouchText: {
        en: "Have any questions left?",
        uk: "Have any questions left?",
    },
    LIbPTCrossPlatformGetInTouchEmail: {
        en: "Lorem@ipsum.dolor",
        uk: "Lorem@ipsum.dolor",
    },
    LIbPTCrossPlatformGetInTouchButton: {
        en: "Ask us!",
        uk: "Ask us!",
    },
};
